"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINKS = void 0;
exports.LINKS = {
    DATA_DICTIONARY_HELP_ARTICLE: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/16466017481357-Data-Dictionary',
    PULSE_HELP_ARTICLE: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/19859886861709',
    SALESFORCE_MANAGE_APPS: (subdomain) => `https://${subdomain}.lightning.force.com/lightning/setup/ConnectedAppsUsage/home`,
    SALESFORCE_MANAGE_OBJECTS: (subdomain) => `https://${subdomain}.lightning.force.com/lightning/setup/ObjectManager/home`,
    SALESFORCE_MANAGE_USERS: (subdomain) => `https://${subdomain}.lightning.force.com/lightning/setup/ManageUsers/home`,
    SETUP_AUDIT_TRAIL_HELP_ARTICLE: 'https://sonarsoftware.zendesk.com/hc/en-us/articles/32418358309005-Setup-Audit-Trail'
};
//# sourceMappingURL=LINKS.js.map